<template>
  <div class="account-select">
    <div
      class="account-select__account"
      @click="openMenuAccounts"
      data-test-id="account-select__button"
    >
      <span>{{ account.name }}</span>
      <i class="icon-nav-bullet_down" />
    </div>

    <ul
      class="account-select__accounts-list"
      v-if="showAccounts"
      @mouseleave="mouseLeaveMenuAccounts"
      ref="accountSelect"
      data-test-id="account-select__list"
    >
      <p>
        Escolha uma conta
        <i class="icon-nav-bullet_up" />
      </p>
      <template v-for="(account, index) in accounts" :key="index">
        <li @click="account.action" data-test-id="account-select__option">
          {{ account.label }}
        </li>
      </template>
    </ul>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed, nextTick } from "vue";
import { useStore } from "vuex";
import getAccount from "@/components/atomic/organisms/navMenuNave/account";
import { IAccount, IAccountList } from "@/common/services/users/interfaceUsers";

export default defineComponent({
  name: "AccountSelect",

  setup() {
    const showAccounts = ref(false);
    const accountSelect: any = ref<HTMLElement | null>(null);
    const store = useStore();
    const { account } = getAccount();

    const openMenuAccounts = () => {
      window.removeEventListener("click", openMenuAccounts, false);

      showAccounts.value = !showAccounts.value;

      checkElementVisibleScreen();
    };

    const checkElementVisibleScreen = () => {
      nextTick(() => {
        if (accountSelect.value) {
          const sizeRange = 30;

          let divElementDementions =
            accountSelect.value.getBoundingClientRect();

          let currentDementions = {
            right: divElementDementions.right + sizeRange,
          };

          let fullSizeToGoBackLeft = 0;

          do {
            fullSizeToGoBackLeft +=
              currentDementions.right >= window.innerWidth ? sizeRange : 0;
            accountSelect.value.style.transform = `translateX(-${fullSizeToGoBackLeft}px)`;
            divElementDementions = accountSelect.value.getBoundingClientRect();

            currentDementions.right = divElementDementions.right + sizeRange;
          } while (currentDementions.right >= window.innerWidth);
        }
      });
    };

    const mouseLeaveMenuAccounts = () => {
      window.addEventListener("click", openMenuAccounts, false);
    };

    const handleAccountSwitch = async (account: IAccount) => {
      localStorage.setItem("ACCOUNT", JSON.stringify(account));
      window.location.reload();
    };

    const accounts = computed(() => {
      const accounts: IAccountList[] = [];

      store.getters["user/accounts"].map((newAccount: IAccount) => {
        let accountToPush: IAccountList = {
          code: newAccount.code,
          divider: false,
          label: newAccount.name,
          action: () => handleAccountSwitch(newAccount),
        };

        if (newAccount.name !== account.value.name) {
          accounts.push(accountToPush);
        }
      });

      return accounts.sort((a, b) => {
        const valueA = (a.label as string).toUpperCase();
        const valueB = (b.label as string).toUpperCase();

        if (valueA < valueB) {
          return -1;
        }
        if (valueA > valueB) {
          return 1;
        }
        return 0;
      });
    });

    return {
      accountSelect,
      account,
      showAccounts,
      accounts,
      openMenuAccounts,
      mouseLeaveMenuAccounts,
    };
  },
});
</script>

<style lang="scss">
.account-select {
  position: relative;
  font-family: "text-medium";

  &__account {
    cursor: pointer;
    font-size: toRem(16px);
    color: var(--insights-color-16);
    display: flex;
    align-items: center;

    > i {
      margin-left: 10px;
      font-size: toRem(11px);
    }
  }

  &__accounts-list {
    list-style: none;
    overflow-y: auto;
    position: absolute;
    max-height: calc(100vh - 4.4rem);
    top: 0;
    left: 0;
    background: var(--insights-color-2);
    width: toRem(226px);
    padding: 1.1rem 1.3rem;
    box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    color: #989898;
    font-size: toRem(15px);
    z-index: 10;

    p {
      text-transform: uppercase;
      font-size: toRem(13px);
      color: #c9c9c9;
      cursor: default;
      font-family: "text-bold";
      display: flex;
      width: 100%;
      justify-content: space-between;
      align-items: center;

      > i {
        font-size: toRem(11px);
      }
    }

    li {
      cursor: pointer;
      margin-bottom: toRem(13px);

      &:hover {
        color: var(--insights-color-1);
      }

      &:last-child {
        margin-bottom: 0px;
      }
    }
  }
}
</style>
